<div class="d-flex ts-col-100 view-test-data">
<app-test-data-grid class="ml-n20"
  [testData]="testData" [testDataForm]="testDataForm" *ngIf="testData"></app-test-data-grid>
</div>
